import { api } from '../lib/api'

export interface ActionBucket {
  total: number
  trabalhadas: number
  feito: number
  comentarios: number
}

export interface DashboardClientRow {
  id: string
  name: string
  reports: number
  actionsCreated: number
  analyses: number
  trabalhadas: number
  feito: number
  comentarios: number
  // Nível de conhecimento da IA sobre o cliente (0–100).
  knowledge: { score: number; level: string; label: string; missingSections: string[] } | null
}

export interface DashboardData {
  scope: 'admin' | 'manager'
  weekActions: ActionBucket
  totalActions: ActionBucket
  clients: DashboardClientRow[]
  // O que espera o gerente na caixa da IA.
  inbox: { questions: number; proposals: number }
  // Portal: pedidos do cliente sem resposta e "Não reconheço" sem solução.
  portal: { requests: number; alerts: number }
}

export const dashboardApi = {
  // managerId (só admin): vê o dashboard com a visão daquele gerente.
  get: (managerId?: string) =>
    api.get<DashboardData>(
      `/dashboard${managerId ? `?managerId=${encodeURIComponent(managerId)}` : ''}`
    ),
}
